import { TimeFrameTypes } from "./enums";

interface DashboardTotalEngagementOutcome {
  totalCount: number;
}

export interface EngagementOutcomeByPeriodPostDto {
  locationId?: number;
  startDate?: string;
  endDate?: string;
  period: TimeFrameTypes;
}

export class EngagementOutcome {
  startDate: string;
  totalCount: number;
  name: string;
  color: string;
  deliveryChannel?: string;
  deliverySource?: string;
}

export interface EngagementOutcomeByPeriodGetDto<EngagementOutcome> {
  data: EngagementOutcome[];
  endDate: string;
  startDate: string;
  total: number;
}

export interface EngagementOutcomeByPeriod extends DashboardTotalEngagementOutcome {
  totalCount: number;
  name: string;
  startDate: string;
  data: EngagementOutcome[];
  color: string;
  deliveryChannel?: string;
  deliverySource?: string;
}

export interface TotalEngagementOutcomeCardInfo {
  totalCount: number;
  list: EngagementOutcomeCardInfoItem[];
}
export interface EngagementOutcomeCardInfoItem {
  label: string;
  value: number;
  progressPerCent: number;
  color?: string;
}

export interface EngagementOutcomeCardInfo {
  maxCount: number;
  list: EngagementOutcomeCardInfoItem[];
}

export class EngagementOutcomeColorSetting {
  color: string;
  deliveryChannel?: string;
  deliverySource?: string;
}

export const engagementOutcomeColorSettings: EngagementOutcomeColorSetting[] = [
  { color: "#ffdd00", deliveryChannel: "Email" },
  { color: "#8000ff", deliveryChannel: "Sms" },
  { color: "#DAFFD6", deliveryChannel: "HyperLink" },

  { color: "#40ff00", deliverySource: "LandingPage" },
  { color: "#FF4500", deliverySource: "Cmc" },
  { color: "#ADFF2F", deliverySource: "Printed" },
  { color: "#0080ff", deliverySource: "Kiosk" },
  { color: "#DA70D6", deliverySource: "Cfs" },
  { color: "#5988FF", deliverySource: "Pos" },
  { color: "#000", deliverySource: "Custom" },
  { color: "#4BA3C3", deliverySource: "Stand" },
  { color: "#6DA34D", deliverySource: "SquareSticker" },
  { color: "#7C90DB", deliverySource: "CircleSticker" },
  { color: "#FF69B4", deliverySource: "NfcStand" },
  { color: "#20B2AA", deliverySource: "NfcStickerRound" },
  { color: "#DDA0DD", deliverySource: "NfcStickerSquare" },
  { color: "#CD853F", deliverySource: "LeatherKeychain" },
  { color: "#9370DB", deliverySource: "NfcPvc" },
  { color: "#48D1CC", deliverySource: "PhoneCard" }
];
